// productNode refers to the element where the variant id is stored.
// This element is dynamically updated when the user selects a new variant.
// The default id is the selected or first variant available.
const productNode = document.querySelector("[data-product]");
document.addEventListener("variant:change", function(evt) {
  productNode.dataset.variantId = evt.detail.variant.id;
});


// We get the cylindo feature set for every variant available on this product along with the variant id to match with the selected variant.

// CustomerID is the id of the account on cylindo (can be found on the Cylindo CMS).
// productCode is the code of the product on cylindo (can be found on the Cylindo CMS).
const cylindoData = {
  customerID: 5126,
  productCode: productNode.dataset.cylindoProductCode,
  remoteConfig: productNode.dataset.cylindoRemoteConfig,
};

// Destructuring the cylindoData object
const { customerID, productCode, remoteConfig } = cylindoData;

// Prepare the viewer instance variable
const viewerInstance = null;

const cylindoFeatures = document.querySelector(
  "[data-cylindo-features]"
).textContent;
const cylindoFeaturesJsonData = JSON.parse(cylindoFeatures);

let cylindoFeaturesArrayToObject = {}

// This method gets the new features based on the new variant that is selected
const getFeatures = function() {
  var variant = cylindoFeaturesJsonData.find(function(el) {
    return el.id == productNode.dataset.variantId;
  });

  for (let i = 0; i < variant.features.length; i += 2) {
    const property = variant.features[i];
    const value = variant.features[i + 1];
    cylindoFeaturesArrayToObject[property] = value;
  }

  return cylindoFeaturesArrayToObject || [];
};

// Prepare the initial set of features.
let features = getFeatures()

// We select our wrapper element where we want to append the viewer.
// We create the viewer element and the thumbnail bar element and append them to the wrapper.
const cylindoViewerWrapperEl = document.querySelector("[data-cylindo-wrapper]");
const cylindoViewerEl = document.createElement("cylindo-viewer");
const cylindoThumbnailBar = document.createElement("cylindo-thumbnail-bar");

// We create a tooltip slot element.
const cylindoTooltipSlotEl = document.createElement("slot");
cylindoTooltipSlotEl.setAttribute("name", "custom-tooltip");
cylindoTooltipSlotEl.classList.add("tooltip-bar-slot");

// We create a tooltip content element and append it to the viewer.
const cylindoTooltipContentEl = document.createElement("cylindo-tooltip");
cylindoTooltipContentEl.setAttribute("slot", "custom-tooltip");

// We create a htmlElement and append it to the tooltip content element.
const cylindoTooltipHTMLElement = document.createElement("div");
cylindoTooltipHTMLElement.classList.add("cylindo-tooltip");
cylindoTooltipHTMLElement.textContent = productNode.dataset.cylendoTooltips ? productNode.dataset.cylendoTooltips : "Click and drag to rotate | Double click to zoom";

// We append the tooltip content element to the tooltip slot element.
cylindoTooltipContentEl.appendChild(cylindoTooltipHTMLElement);

// We append the tooltip slot element to the viewer.
cylindoViewerEl.appendChild(cylindoTooltipContentEl);

// Create a stylesheet element
const cylindoStylesheet = document.createElement("style");

// Set the content of the stylesheet
// This is needed to change the order of the thumbnail bar and the tooltip bar
cylindoStylesheet.textContent = `
.layoutWrapper slot.tooltip-bar-slot{
  order:8; 
  display: inline-block;
  max-width: 100%;
  width: fit-content;
  margin: auto;} 
  
  [part="thumbnail-bar-fullscreen-container"] + slot.tooltip-bar-slot{
    
    display: none;
  }

.layoutWrapper slot.thumbnail-bar-slot{order:9;}
`;




// cylindoViewerEl.features = {};
// for (let i = 0; i < cylindoFeaturesJsonData.features.length; i += 2) {
//   const property = cylindoFeaturesJsonData.features[i];
//   const value = cylindoFeaturesJsonData.features[i + 1];
//   cylindoViewerEl.features[property] = value;
// }


// If we have all the data required to create the viewer instance
// Then we create the viewer instance using the options object.
if (customerID && productCode && features) {
  window.customElements.whenDefined("cylindo-viewer").then(() => {
    cylindoViewerWrapperEl.appendChild(cylindoViewerEl);
    cylindoViewerEl.appendChild(cylindoThumbnailBar);
    cylindoViewerEl["code"] = productCode;
    cylindoViewerEl["customer-id"] = customerID;
    cylindoViewerEl["features"] = features;
    cylindoViewerEl["lang"] = "da";

    cylindoViewerEl.locales = {
      ...cylindoViewerEl.locales,
      da: {
        viewInAR: window.theme.strings.cylindoViewInHome,
        "qr.alt": window.theme.strings.cylindoQRalt,
        "qr.usage": window.theme.strings.cylindoQRusage,
        "qr.requirements.key": window.theme.strings.cylindoQRrequirementsKey,
        "qr.requirements.value": window.theme.strings.cylindoQRrequirementsValue,
      }
    }

    if (cylindoData.remoteConfig) {
      cylindoViewerEl["remote-config"] = remoteConfig
    }

    // If Cylindo has loaded, create the viewer instance using the feature set given by getFeatures()
    productNode.addEventListener("change", function() {
      features = getFeatures();

      // Update the viewer
      cylindoViewerEl.features = features;
    });

    cylindoViewerWrapperEl.classList.remove("hidden");


    // We select the viewer element and append the tooltip slot element to the viewer.
    const viewer = document.querySelector("cylindo-viewer");

    // Append the stylesheet to the viewer element
    viewer.shadowRoot.appendChild(cylindoStylesheet);


    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const thumbnailBarSlot = viewer.shadowRoot.querySelector('.layoutWrapper slot[name="thumbnail-bar"]');
          if (thumbnailBarSlot !== null) {
            thumbnailBarSlot.parentNode.appendChild(cylindoTooltipSlotEl);
            observer.disconnect();
          }
        }
      }
    });

    observer.observe(viewer.shadowRoot, { childList: true, subtree: true });

  });
} else {
  // If the information required to build the new instance is not present, then show the error and display the default viewer
  console.log("Missing information to create 360 viewer");
}
